import { useTranslation } from "react-i18next";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Grid,
    Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { MapItTextField } from "src/components/common";
import { UploadImageCard } from "src/_modules/common";
import { startsWith } from "lodash";
import { USER_ROLES_TYPES } from "src/constants";

export default function LocationPageSettings({
    profile,
    onLocationPageSettingsUpdated,
    onChange,
    loading,
    error,
    isSuccess,
    validationErrors,
    type
}) {
    const { t } = useTranslation();

    return (
        <Card>
            <CardHeader
                title={t("Page Settings Order Tracking")}>
            </CardHeader>
            <Divider />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={6} >
                        <UploadImageCard
                            title={t("Choose Logo")}
                            name="locationPageLogo"
                            image={profile?.locationPageLogo ?? ''}
                            handleChange={onChange}
                            error={validationErrors?.locationPageLogo ?? ''}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <MapItTextField
                            label={t("Color")}
                            name="locationPageColor"
                            value={profile?.locationPageColor ?? ""}
                            required={true}
                            handleChange={onChange}
                            type="color"
                            error={validationErrors?.locationPageColor ?? ''}
                        />
                    </Grid>
                </Grid>
                <Typography mt={1}>
                    {t("*Logo dimensions 256*256")}
                </Typography>
            </CardContent>
            <Divider />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: error || isSuccess ? "space-between" : "flex-end",
                    alignItems: 'center',
                    p: 2,
                }}
            >
                {!!error && <Typography color='text.danger'>{t(error)}</Typography>}
                {isSuccess && <Typography color='success.main'>{t("Done successfully")}</Typography>}
                <LoadingButton
                    onClick={onLocationPageSettingsUpdated}
                    variant="contained"
                    disableElevation
                    loading={loading}
                    disabled={type === USER_ROLES_TYPES.SUB_ADMIN}
                    sx={{
                        mt: 1,
                        textTransform: "none",
                        fontWeight: "bold",
                    }}
                >
                    {t("Save")}
                </LoadingButton>
            </Box>
        </Card>
    );
};
